import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class HeatMapService {

	private URL = environment.api + "api/erp/heapMap";

	constructor(private http: HttpClient) { }

	getHeatMap(warehouse, year, month, type) {
		return this.http.get(this.URL, {
			params: {
				warehouse: warehouse,
				year: year,
				month: month,
				type: type
			}
		})
	}

	getHeatMapOutcome(warehouse, year, month, type) {
		return this.http.get(this.URL + "/outcome", {
			params: {
				warehouse: warehouse,
				year: year,
				month: month,
				type: type
			}
		})
	}
}